import { render, staticRenderFns } from "./YourMessage.vue?vue&type=template&id=38ab2510"
import script from "./YourMessage.vue?vue&type=script&lang=js"
export * from "./YourMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports